import styled from '@emotion/styled/macro'
import { Box } from '@mui/material'
import theme from 'theme'

export const SearchBarWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  position: sticky;
  top: 0;
  z-index: 1;
  border-radius: 8px;
  margin: 8px;

  .MuiOutlinedInput-root {
    height: 36px;

    .MuiOutlinedInput-input {
      height: 36px;
    }
  }

  .search-icon {
    position: absolute;
    left: 10px;
    top: 9px;
    z-index: 1;
  }

  .search-bar-clear-btn {
    position: absolute;
    right: 0;
    top: -1px;
  }

  .search-bar-text-field {
    width: 100%;
    border-radius: 28px;
    height: 36px;
  }

  .MuiOutlinedInput-input {
    border-radius: 8px;
    border: 1px solid #292128;
    background: #292128;

    html[data-theme='light'] & {
      border-color: ${theme.colors.dropdownBorder};
      background: ${theme.colors.menuItemHover};
    }
    height: 36px;
    padding: 0 40px 0 36px;
    color: ${theme.colors.devicesSecondaryText};
    font-family: Quicksand, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;

    &::placeholder {
      opacity: 1;
      color: ${theme.colors.devicesSecondaryText};
      font-family: Quicksand, sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }

    &:focus {
      border-color: ${theme.colors.cta};
    }
  }

  fieldset {
    border: none;
  }
`
